import { createContext } from "react";

const DonationMasterContext = createContext({});

export default DonationMasterContext;
